import KeenSlider from "keen-slider";

class News {
	constructor(dom) {
		this.NAME = "News";
		this.dom = dom;
		this.row = dom.querySelector("[data-news-row]");
		this.prev = dom.querySelector("[data-news-prev]");
		this.next = dom.querySelector("[data-news-next]");
		this.slider = null;
	}

	init() {
		if (!this.row) return;

		// perView values mirror the old flex-basis breakpoints (85% / 45% / 28%)
		// as their reciprocals, so the same number of cards is visible at each
		// width — Keenslider owns sizing/sliding now, not CSS flex-basis.
		this.slider = new KeenSlider(this.row, {
			slides: { perView: 1, spacing: 20 },
			breakpoints: {
				"(min-width: 720px)": { slides: { perView: 2, spacing: 20 } },
				"(min-width: 1024px)": { slides: { perView: 3, spacing: 20 } },
			},
		});

		if (this.prev)
			this.prev.addEventListener("click", () => this.slider.prev());
		if (this.next)
			this.next.addEventListener("click", () => this.slider.next());
	}
}

export default News;
